"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPromoCodeToCart = void 0;
const utils_1 = require("../../../utils");
const buildPath = (cartId) => `/v1/bff/appro/carts/${cartId}/promo-codes`;
const addPromoCodeToCart = (client) => async ({ cartId, ...body }) => {
    try {
        const { data } = await client.post(buildPath(cartId), body);
        return { cart: data };
    }
    catch (error) {
        if ((0, utils_1.isFunctionalApiError)(error)) {
            return {
                error: {
                    code: error.body.code,
                    message: error.body.message
                }
            };
        }
        throw error;
    }
};
exports.addPromoCodeToCart = addPromoCodeToCart;
